<template>
    <form @submit.prevent="$emit('handle-click')">
        <div class="flex items-center mt-1">
            <div class="flex-1">
                <jet-input
                    v-if="mask"
                    class="block w-full text-md"
                    v-mask="mask"
                    :placeholder="placeholder"
                    :value="value"
                    @input="$emit('input', $event)"
                />
                <jet-input
                    v-else class="block w-full text-md"
                    :placeholder="placeholder"
                    :value="value"
                    @input="$emit('input', $event)"
                />
            </div>
            <a :href="(hrefButton || null)" class="cursor-pointer bg-gray-900 text-white rounded p-3 text-sm ml-3 hover:bg-gray-800">
                {{ textButton }}
            </a>
        </div>
        <jet-input-error :message="error" class="mt-1" />
    </form>
</template>

<script>
import JetInput from "../../../Jetstream/Input.vue";
import JetInputError from "../../../Jetstream/InputError.vue";

export default {
    name: 'inputWithButton',
    props: {
        value: { type: String, default: '' },
        mask: { type: [Array, null], default: null },
        textButton: { type: String, default: 'button' },
        placeholder: { type: String, default: '' },
        hrefButton: { type: String, default: '' },
        error: { type: String, default: '' }
    },
    components: {
        JetInput,
        JetInputError
    }
}
</script>
